import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  formControlCls: {
    width: '260px',
    backgroundColor: '#ffffff',
    '& .MuiSelect-nativeInput': {
      width: 260,
      padding: 0,
      border: 'none'
    },
    '& label': {
      fontSize: '16px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '0',
      letterSpacing: '-0.5px',
      color: '#cccccc',
      overflow:'visible'
    },
    '& .MuiSelect-iconOutlined': {
      right: '15px',
      top: 'calc(50% - 9px)',
      height: '18px',
      width: '18px'
    },
    '& .MuiOutlinedInput-input': {
      padding: '12px 14px',
      lineHeight: '1.1876em'

    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, -1px) scale(0.75)'
    }
  },
  selectMenuPopover: {
    boxShadow: "0px 5px 12px rgba(0, 0, 0, 0.08)",
    borderRadius: 0
  },
  menuItem: {
    padding:'10px',
    width: 240,
    margin: '2px 10px',
    lineHeight: '18px',
    fontWeight: 450,
    borderRadius: 4,
    whiteSpace: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&.MuiMenuItem-root:hover': {
      color: '#131313',
      backgroundColor: '#EAF3FF'
    },
    '&.MuiMenuItem-root.Mui-selected, &.MuiListItem-root.Mui-selected:hover, &.MuiListItem-root.Mui-selected .menuOpen': {
      color: '#fff !important',
      backgroundColor: '#2D91E9 !important'
    },
    '&.MuiMenuItem-root.Mui-selected label': {
      color: '#fff !important'
    },
    '&.MuiListItem-gutters': {
      padding: 10
    },
    '& .MuiTouchRipple-root': {
      display: 'none'
    }
  },
  responsiveMenuItem:{
    width: 'auto'
  },
  subMenuFormControlCls: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    padding:0,
    '& label': {
      padding:'10px',
      fontSize: '16px',
      fontWeight: '450',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '18px',
      letterSpacing: '-0.5px',
      color: '#131313',
      position: 'relative',
      transform: 'none',
      alignSelf: 'flex-start',
      whiteSpace: 'normal',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    '&.menuOpen': {
      color: '#FFF',
      backgroundColor: '#2D91E9'
    }
  },
  subDropdownButton: {
    padding: 0,
    height: 38,
    borderRadius: '0px',
    backgroundColor: 'transparent',
    '&.MuiButton-contained:hover': {
      backgroundColor: 'transparent'
    }
  },
  tickIcon: {
    marginInlineStart: 'auto',
  },
  subMenuItem: {
    padding:0,
    '&.MuiListItem-gutters': {
      padding: 0
    }
  },
  subMenuPopover: {
    width: 260,
    boxShadow: '0px 5px 12px rgba(0, 0, 0, 0.08)',
    marginTop: 10,
    maxHeight: 400
  }
});
